import SvgIcon from '../core/SvgIcon';
import { ReactComponent as Icon }  from '../../assets/icons/google-maps.svg';

const GoogleMaps = ({
    width = 24,
    height = 24,
    fill = "#666666",
    className = "",
    ...props
}) => <SvgIcon className={`${className} grayscale hover:grayscale-0 transition-all duration-200`} Icon={Icon} width={width} height={height} fill={fill} {...props} />;

export default GoogleMaps;
